// extracted by mini-css-extract-plugin
export var disclaimer = "disclaimer-module--disclaimer--25n6E";